import { Spinner } from '@frontend/elements';
import React from 'react';

import { OnDutyOpenSlotButton } from '../../on-duty-open-slot/on-duty-open-slot.component';
import SlotStatus from '../../slot-status/slot-status.component';
import { UserInterfaceProps } from '../../types/user-interface';
import useOnDutyCustomerDropOff from './on-duty-customer-drop-off.controller';

export const OnDutyCustomerDropOff = (props: UserInterfaceProps) => {
    const viewProps = useOnDutyCustomerDropOff(props);

    if (!viewProps.slot) {
        return <Spinner />;
    }

    if (viewProps.isSlotOpening) {
        return (
            <SlotStatus
                {...props}
                data={{
                    account_id: viewProps.slot.account_id,
                    spot_id: viewProps.slot.spot_id,
                    module_id: viewProps.slot.module_id,
                    slot_id: viewProps.slot.id
                }}
                type={'drop'}
            />
        );
    }

    return (
        <div
            className='justify-content-center align-content-center'
            style={{ height: '90%' }}>
            <div className='d-flex justify-content-center align-content-center'>
                <OnDutyOpenSlotButton callback={() => viewProps.changeIsSlotOpening(true)} />
            </div>
        </div>
    );
};
